"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectionItemValue = exports.SlottedSelectionController = void 0;
/**
 * slot으로 받은 항목을 선택 컨트롤러에 잇는 배관. 값은 소유하지 않는다.
 * 값 자체는 selection이 소유하고, 이 컨트롤러는 항목 수집 → 마크업 초기 선택 흡수 →
 * 그룹 상태를 항목에 반영 → 항목의 change를 그룹 change로 승격까지의 왕복만 맡는다.
 * 호스트가 갱신될 때마다 항목에 다시 반영하므로 호스트는 sync를 직접 부르지 않는다.
 * checkbox·radio 계열 그룹이 초기화·커밋 순서를 같게 갖는 것이 목적이다.
 */
class SlottedSelectionController {
    constructor(host, options) {
        this.options = options;
        // 첫 slot 배정 전에는 마크업이 선언한 초기 선택을 아직 읽지 못한 상태다.
        this.initialized = false;
        /** slot의 slotchange에 그대로 연결한다. */
        this.handleSlotChange = () => {
            if (!this.initialized)
                this.absorbInitialSelection();
            this.initialized = true;
            this.sync();
        };
        /** 항목의 change가 올라오는 컨테이너에 그대로 연결한다. */
        this.handleItemChange = (event) => {
            const item = this.options.getItems().find(candidate => candidate === event.target);
            if (!item)
                return;
            // 항목 단위 이벤트는 여기서 끊고 그룹 단위 change로 승격한다.
            event.stopPropagation();
            this.options.selection.setSelected({ value: (0, exports.selectionItemValue)(item) }, item.checked);
            this.sync();
            this.options.onChange();
        };
        host.addController(this);
    }
    hostUpdated() {
        this.sync();
    }
    /** 그룹이 소유한 선택 상태를 항목에 되돌린다. */
    sync() {
        // 첫 렌더의 updated()는 slotchange보다 먼저 도는데, 그때 되돌리면
        // 마크업이 선언한 초기 선택을 흡수하기도 전에 지워버린다.
        if (!this.initialized)
            return;
        this.options.getItems().forEach(item => {
            this.options.applyItem?.(item);
            item.checked = this.options.selection.isSelected((0, exports.selectionItemValue)(item));
        });
    }
    // 마크업이 선언한 초기 선택은 그룹이 아직 값을 갖지 않았을 때만 흡수한다.
    // 항목 순서대로 위임하므로 다중 선택은 전부 남고, 단일 선택은 네이티브 radio처럼 마지막 항목이 남는다.
    absorbInitialSelection() {
        if (!this.options.selection.isEmpty())
            return;
        this.options
            .getItems()
            .filter(item => item.checked)
            .forEach(item => this.options.selection.setSelected({ value: (0, exports.selectionItemValue)(item) }, true));
    }
}
exports.SlottedSelectionController = SlottedSelectionController;
/** 아직 업그레이드되지 않은 항목도 값을 잃지 않도록 attribute를 함께 본다. */
const selectionItemValue = (item) => item.value || item.getAttribute('value') || '';
exports.selectionItemValue = selectionItemValue;
//# sourceMappingURL=data:application/json;base64,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